import { DateTime } from 'luxon';
export interface AppointmentDtoType {
    id: number;
    typeValue:
        | 'INITIAL_APPOINTMENT'
        | 'FOLLOW_UP_APPOINTMENT'
        | 'GENERIC_APPOINTMENT'
        | 'CUSTOMER_PRESENTATION'
        | 'POSTPONED_APPOINTMENT'
        | 'INITIAL_CALL'
        | 'FOLLOW_UP_CALL'
        | 'NOTE'
        | 'CONTROL';
    localizedTypeValue: String;
}

export default class AppointmentDto {
    id: number;
    createdOn: DateTime;
    tookPlaceOn?: DateTime;
    appointmentDate?: DateTime;
    type: AppointmentDtoType;
    note?: string;

    constructor(json: any) {
        this.id = json.id;
        this.createdOn = DateTime.fromISO(json.createdOn);
        this.tookPlaceOn = json.tookPlaceOn ? DateTime.fromISO(json.tookPlaceOn) : undefined;
        this.appointmentDate = json.appointmentDate ? DateTime.fromISO(json.appointmentDate) : undefined;
        this.type = json.type;
        this.note = json.note ? json.note : undefined;
    }

    public is(typeValue: AppointmentDtoType['typeValue'] | AppointmentDtoType['typeValue'][]): boolean {
        if (Array.isArray(typeValue)) {
            return typeValue.includes(this.type.typeValue);
        }
        return this.type.typeValue === typeValue;
    }
}
